<template>
  <fragment>
    <!-- CONTACT FORM START -->
    <v-container class="my-5">
      <v-row>
        <v-col cols="12">
          <v-card style="overflow: hidden;" elevation="3">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="5" class="pa-0">
                  <v-img :src="require(`../assets/tmx_contact_form_bg_6.jpg`)" class="align-stretch" cover
                         height="100%" aspect-ratio="1.333" position="center center">
                    <div class="d-flex flex-column justify-space-around" style="height: 100%;">
                      <v-icon color="white" x-large v-show="$vuetify.breakpoint.mdAndUp">
                        mdi-email
                      </v-icon>
                      <!--<div class="white&#45;&#45;text text-center headline align-self-center">
                        {{ $t('ourEmail') }}:<br><a class="body-1 white&#45;&#45;text">allas@tmx.hu</a>
                      </div>-->
                      <v-icon color="white" x-large v-show="$vuetify.breakpoint.mdAndUp">
                        mdi-phone
                      </v-icon>
                    </div>
                  </v-img>
                </v-col>
                <v-col cols="12" md="7" class="px-10 py-12">
                  <v-form v-model="contactFormIsValid">
                    <v-row>
                      <v-col cols="12" class="py-2">
                        <v-select v-model="contactForm.divisionId"
                                  :items="selectFieldOptions.divisions"
                                  :label="$t('inputLabels.field')"
                                  :rules="inputRules.generalRules"
                                  outlined
                                  dense
                                  :disabled="propsDivisionId && propsDivisionId > 0"
                                  required>
                        </v-select>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-select v-model="contactForm.jobId"
                                  :items="selectFieldOptions.jobs"
                                  :label="$t('inputLabels.job')"
                                  :rules="inputRules.generalRules"
                                  outlined
                                  required
                                  dense
                                  :disabled="propsJobId && propsJobId > 0">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.visitor.lastName"
                                      :label="$t('inputLabels.lastName')"
                                      :rules="inputRules.generalRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <!--<v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.visitor.middleName"
                                      :label="$t('inputLabels.middleName')"
                                      outlined
                                      dense>
                        </v-text-field>
                      </v-col>-->
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.visitor.firstName"
                                      :label="$t('inputLabels.firstName')"
                                      :rules="inputRules.generalRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.visitor.email"
                                      :label="$t('inputLabels.email')"
                                      :rules="inputRules.emailRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="py-2">
                        <v-text-field v-model="contactForm.visitor.phone"
                                      :label="$t('inputLabels.phone')"
                                      :rules="inputRules.phoneRules2"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      prefix="+36-"
                                      v-mask="phoneMask"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-file-input v-model="attachment.cv"
                                      :label="$t('inputLabels.cv')"
                                      accept=".pdf"
                                      show-size
                                      outlined
                                      dense
                                      ref="valami">
                          <template v-slot:selection="{text}">
                            <v-chip small label color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-file-input v-model="attachment.document"
                                      :label="$t('inputLabels.otherDoc')"
                                      accept=".pdf"
                                      counter
                                      show-size
                                      outlined
                                      dense>
                          <template v-slot:selection="{text}">
                            <v-chip small label color="primary">
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-text-field v-model="contactForm.netSalary"
                                      :label="$t('inputLabels.netSalary')"
                                      :rules="inputRules.phoneRules"
                                      :hint="$t('inputMessages.requiredField')"
                                      persistent-hint
                                      suffix="Ft"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-select v-model="contactForm.sourcePage"
                                  :items="selectFieldOptions.sourcePages"
                                  :label="$t('inputLabels.sourcePage')"
                                  :rules="inputRules.generalRules"
                                  :hint="$t('inputMessages.requiredField')"
                                  persistent-hint
                                  outlined
                                  dense
                                  required>
                        </v-select>
                      </v-col>
                      <v-col v-if="contactForm.sourcePage === 'Egyéb'" cols="12" class="py-2">
                        <v-text-field v-model="contactForm.sourceOther"
                                      :label="$t('inputLabels.sourceOther')"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col v-if="contactForm.sourcePage === 'Dolgozói ajánlás útján'" cols="12" class="py-2">
                        <v-text-field v-model="contactForm.sourceSponsor"
                                      :label="$t('inputLabels.sourceSponsor')"
                                      outlined
                                      dense
                                      required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="py-2">
                        <v-checkbox
                          v-model="contactFormCheckbox"
                          :rules="inputRules.gdprRules"
                          required
                        >
                          <template slot="label">
                            <span v-show="$i18n.locale === 'hu-HU'" class="body-2">Az&nbsp;<a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Adatvédelmi tájékoztatót</a>&nbsp;elolvastam és elfogadom.</span>
                            <span v-show="$i18n.locale === 'en-EN'" class="body-2">I have read and accept the&nbsp;<a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Privacy Policy</a>.</span>
                            <span v-show="$i18n.locale === 'de-DE'" class="body-2">Ich habe das&nbsp;<a :href="`${publicPath}doc/Adatvedelmi_Tajekoztato_Honlap_Latogatoknak.pdf`" target="_blank" @click.stop>Datenschutz</a> gelesen und akzeptiere es.</span>
                          </template>
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12">
                        <v-row justify="end">
                          <v-btn rounded large color="primary" :disabled="!contactFormIsValid" @click="sendContactForm">
                            {{ $t('button.send') }}
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="text-center">
          Ha mégis email-t írnál nekünk: <a href="mailto:allas@tmx.hu">allas@tmx.hu</a>
        </v-col>
      </v-row>
    </v-container>
    <!-- CONTACT FORM END -->
    <!-- RESPONSE DIALOGS START -->
    <v-dialog v-model="loadingDialog.visible" width="90%" max-width="340" :persistent="true">
      <loading-dialog v-bind:loading-message="loadingDialog.message" />
    </v-dialog>
    <v-dialog v-model="responseDialog.visible" width="90%" max-width="340" :persistent="true">
      <response-dialog v-bind:response-object="responseDialog.response"
                       v-on:close-dialog="closeResponseDialog"/>
    </v-dialog>
    <!-- RESPONSE DIALOGS END -->
  </fragment>
</template>

<script>
import responseDialog from './responseDialog.vue';
import loadingDialog from './loadingDialog.vue';
import { UPLOAD_CV_FORM } from '../store/actions.type';

export default {
  name: 'contactFormJobApplication',
  components: {
    responseDialog, loadingDialog,
  },
  props: {
    propsDivisionId: Number,
    propsJobId: Number,
  },
  updated() {
    if (this.propsDivisionId) {
      this.contactForm.divisionId = this.propsDivisionId;
    }
    if (this.propsJobId) {
      this.contactForm.jobId = this.propsJobId;
    }
  },
  data() {
    return {
      phoneMask: '##-###-####',
      contactFormIsValid: false,
      contactFormCheckbox: false,
      loadingDialog: {
        visible: false,
        message: 'loadingMessages.INPROGRESS_CONTACT_FORM',
      },
      responseDialog: {
        visible: false,
        response: {
          error: false,
          data: [],
          message: 'successMessages.SUCCESS_CONTACT_FORM',
        },
      },
      contactForm: {
        divisionId: '',
        jobId: '',
        visitor: {
          firstName: '',
          middleName: '',
          lastName: '',
          email: '',
          phone: '',
          namePrefixId: 1,
          isGdpr: 1,
        },
        netSalary: null,
        sourcePage: '',
        sourceOther: null,
        sourceSponsor: null,
      },
      attachment: {
        cv: [],
        document: [],
      },
      selectFieldOptions: {
        divisions: this.$store.state.generalStore.divisions,
        jobs: this.$store.state.jobsStore.jobsForSelectFieldOptions,
        sourcePages: [
          { value: 'Google (Internet)', text: 'Google (Internet)' },
          { value: 'Facebook', text: 'Facebook' },
          { value: 'LinkedIn', text: 'LinkedIn' },
          { value: 'Profession hirdetés', text: 'Profession hirdetés' },
          { value: 'CV Online hirdetés', text: 'CV Online hirdetés' },
          { value: 'Állásbörze', text: 'Állásbörze' },
          { value: 'Óriás plakát', text: 'Óriás plakát' },
          { value: 'Szórólap/Újság hirdetés', text: 'Szórólap/Újság hirdetés' },
          { value: 'Dolgozói ajánlás útján', text: 'Dolgozói ajánlás útján' },
          { value: 'Egyéb', text: 'Egyéb' },
        ],
      },
      inputRules: {
        generalRules: [v => !!v || 'Kötelező kitölteni'],
        emailRules: [
          v => /.+@.+\..+/.test(v) || 'Érvényes e-mail címet adjon meg!',
        ],
        phoneRules: [
          v => /^[0-9]*$/.test(v) || 'Csak számokat adjon meg!',
          v => !!v || 'Kötelező kitölteni',
        ],
        phoneRules2: [
          v => /^[0-9\-]*$/.test(v) || 'Csak számokat adjon meg!',
          v => !!v || 'Kötelező kitölteni',
        ],
        gdprRules: [
          v => !!v || 'Az űrlap beküldéséhez el kell fogadnia az Adatvédelmi Szabályzatot!',
        ],
      },
      publicPath: process.env.BASE_URL,
    };
  },
  methods: {
    async sendContactForm() {
      this.openLoadingDialog();
      try {
        const response = await this.$store.dispatch(UPLOAD_CV_FORM,
          { form: this.contactForm, attachment: this.attachment });
        if (response.error) {
          this.setupResponseDialog('errorMessages.ERROR_GENERAL_FAIL');
        } else {
          //
        }
        this.controlDialogs();
      } catch (err) {
        this.setupResponseDialog('errorMessages.ERROR_GENERAL_FAIL');
        this.controlDialogs();
      }
    },
    openLoadingDialog() {
      this.loadingDialog.visible = true;
    },
    closeLoadingDialog() {
      this.loadingDialog.visible = false;
    },
    setupResponseDialog(message) {
      this.responseDialog.response.message = message;
    },
    openResponseDialog() {
      this.responseDialog.visible = true;
    },
    closeResponseDialog() {
      this.responseDialog.visible = false;
      this.$router.push('/career');
    },
    controlDialogs() {
      setTimeout(this.closeLoadingDialog, 3000);
      setTimeout(this.openResponseDialog, 3200);
    },
  },
  watch: {
    'contactForm.sourcePage': function (value) {
      this.contactForm.sourceSponsor = null;
      this.contactForm.sourceOther = null;
    },
  },
};
</script>

<style scoped>

</style>
